function searchQuery(term, contentTypes, size = 100) {
    let searchQuery = {
      "size": size,
      "query":{
        "bool":{
          "filter":[{  
            "bool":{
              "should": [
                {
                  "terms": {
                    "content_type.keyword": contentTypes
                  }
                }
              ]
            }
          }],
          "must":[
            {
              "query_string":{
                "query": term,
                "fields": [
                  "name^3",
                  "description",
                  "*"
                ]
              }
            }
          ]
        }
      },
      "highlight":{
        "pre_tags" : ["<u>"],
        "post_tags" : ["</u>"],
        "fields":{
          "*": {},
          "name": { "fragment_size": 0 },
          "description": { "fragment_size": 0 },
          "scenario_text_elements.body": { "fragment_size": 0 },
          "content.body": { "fragment_size": 0 },
          "content.video_text": { "fragment_size": 0 },
          "content.video_type.videoText": { "fragment_size": 0 },
          "learning_goals.content": { "fragment_size": 0 },
          "learning_goals.label": { "fragment_size": 0 },
          "content.contextTitle": { "fragment_size": 0 },
          "content.description": { "fragment_size": 0 },
          "content.video_type.description": { "fragment_size": 0 },
          "content.video_type.videoText": { "fragment_size": 0 },
          "content.contextTitle": { "fragment_size": 0 },
          "video_text": { "fragment_size": 0 },
        },
        "boundary_scanner": "sentence"
      }
    }
    return JSON.stringify(searchQuery)
}

export default searchQuery